import {Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AppService} from "@irb/app.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ComIncludeInScheduledRebalanceDialogGridLayoutService} from "@irb/irb-editors/editor-portfolio/com-include-in-scheduled-rebalance-dialog/com-include-in-scheduled-rebalance-dialog.grid-layout.service";
import {IResponseObject, ISchedule, IScheduledDropdownList} from "@irb/irb-rebalance/scheduled/scheduled.model";
import {ScheduledService} from "@irb/irb-rebalance/scheduled/scheduled.service";
import {HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {SelectAllGridParent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-select-all-grid-parent";
import {IPortfolioExportRequest} from "@irb/irb-clients/irb-clients.model";
import { IrbAppEvents, IEventSubscriber, IEvent } from "@irb/irb-common/events";
import { Subscription } from 'rxjs';
@Component({ standalone: false,
    selector: 'irb-com-include-in-scheduled-rebalance-dialog',
    templateUrl: './com-include-in-scheduled-rebalance-dialog.component.html',
    styleUrls: ['./com-include-in-scheduled-rebalance-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComIncludeInScheduledRebalanceDialogComponent implements OnInit, OnDestroy, SelectAllGridParent, IEventSubscriber {
    scheduledRebalance: any[];
    scheduledTypeList: any = [];
    scheduledOwnerList: any = [];
    loadingOverlayComponentParams: any;
    grid: any;
    gridOptions: any;
    sideBar: any;
    isSelectedAll: boolean = false;
    disableActionBtn = true;
    headerCheckBoxState: string;
    overlayType: any;
    ownerList: any = [];
    currentScheduledDisplayed: any;
    scheduledRebalanceCount: any;
    footerContent: any;
    totalRecordsFromServer: number;
    uniqueField = 'analysisId';
    deselectedFromSelectAllRecords: any[] = [];
    checkSelected: boolean = true;
    continueFunction: (selectedRebalances: any[]) => {};
    eventSubscription: Subscription;
    isUiTest = false;
    selectedRowsMap: Map<string, any> = new Map<string, any>();

    constructor(private as: AppService,
                private readonly scheduledService: ScheduledService,
                public dialogRef: MatDialogRef<ComIncludeInScheduledRebalanceDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private gls: ComIncludeInScheduledRebalanceDialogGridLayoutService) {
                    this.eventSubscription = this.as.getEvents().subscribe((s) => this.processEvent(s));
    }

    ngOnInit(): void {
        this.continueFunction = this.mdd.continueFunction;
        this.loadingOverlayComponentParams = {parentObject: this};
        this.getScheduledRebalanceCount();
        this.gridOptions = {
            rowModelType: 'serverSide',
            columnDefs: this.gls.getColumnDefs(this),
            rowSelection: 'multiple',
            context: {componentParent: this},
            onSortChanged: () => {
                this.setDatasource();
            }
        };

        this.sideBar = {
            toolPanels: [
                {
                    id: 'filters',
                    labelDefault: 'FILTERS',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                    toolPanelParams: {
                        suppressExpandAll: true,
                        suppressFilterSearch: true,
                        suppressSyncLayoutWithGrid: true,
                    },
                }],
            defaultToolPanel: 'filters'
        };
    }

    ngOnDestroy() {
        // if (this.eventSubscription) {
        //     this.eventSubscription.unsubscribe();
        // }
    }

    processEvent(event: IEvent): void {
        switch(event.type) {
            case IrbAppEvents.GRID_FILTER_RESET:
            this.clearAllFilters();
            break;
        }
    }

    getScheduledRebalanceCount(): void {
        this.scheduledService.getScheduledRebalanceCount().subscribe(IResponseObject =>
            this.scheduledRebalanceCount = IResponseObject.responseData);
    }

    clearAllFilters() {
        if (this.grid) {
            this.scheduledService.clearCriteria();
            this.grid.api.deselectAll();
            this.selectedRowsMap = new Map<string, any>();
            this.grid.api.setFilterModel(null);
            this.grid.api.refreshToolPanel();

            this.isSelectedAll = false;
            this.headerCheckBoxState = 'unchecked';
            this.enableDisableBtns();
        }
    }

    enableDisableBtns() {
        this.disableActionBtn = (this.isSelectedAll || this.selectedRowsMap?.size) ? false : true;
    }

    setDatasource() {
        return {
            getRows: (params: any) => {
                this.overlayType = 'loading';
                this.grid.api.showLoadingOverlay();
                this.scheduledService.clearCriteria();
                this.scheduledService.getScheduleRebalanceInv(params).subscribe(data => {
                    this.scheduledRebalance = <ISchedule[]>data.body;
                    this.getCurrentCount(data.headers);

                    if (this.currentScheduledDisplayed === 0) {
                        this.grid.api.showNoRowsOverlay();
                    } else {
                        this.grid.api.hideOverlay();
                    }

                    params.success({ rowData: this.scheduledRebalance });
                });
            }
        };
    }

    getCurrentCount(headers: HttpHeaders) {
        const contentRange = headers.get('Filter-Count');
        const lengthOfContentRange = contentRange ? contentRange.trim().length : 0;
        const indexOfSlash = contentRange ? contentRange.toString().indexOf('/') : 0;
        this.currentScheduledDisplayed = contentRange ? parseInt(contentRange.toString().substring(indexOfSlash + 1, lengthOfContentRange)) : 0;
        this.footerContent = this.currentScheduledDisplayed + ' of ' + this.scheduledRebalanceCount + ' scheduled rebalances displayed';
        this.totalRecordsFromServer = Number(this.currentScheduledDisplayed);
    }

    getOwnerDropdownList() {
        this.scheduledService.getComboDropDownOwner().subscribe((res: IScheduledDropdownList) => {
            this.ownerList = res;
            for (const record of  res.items) {
                if (record.name) {
                    this.scheduledOwnerList.push(record.name);
                }
            }
        });
    }

    close() {
        this.dialogRef.close();
    }

    get portfolioName() {
        if (this.mdd && this.mdd.portfolioData) {
            return this.mdd.portfolioData.portfolioName;
        } else {
            return "";
        }
    }

    proceed() {
        let rebalances = this.isSelectedAll ? [] : this.getSelectedRebalances();
        if (this.isSelectedAll) {
            const request = {} as IPortfolioExportRequest;
            request.isSelectAll = this.isSelectedAll;
            request.deselectedIds = [];

            this.deselectedFromSelectAllRecords.forEach((node: any) => {
                request.deselectedIds.push(node.analysisId);
            });

            request.selectedIds = [];
            this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
            this.scheduledService.getSelectAllScheduledRebalances(request).subscribe((response) => {
                if (response.responseData.length > 0) {
                    rebalances  = [...response.responseData];
                    this.continueFunction(rebalances);
                }
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
                this.close();
            },()=>{
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            },()=>{
                this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            });
        } else {
            this.continueFunction(rebalances);
            this.close();
        }
    }
    getSelectedRebalances() {
        const s: Array<any> = [];
        this.selectedRowsMap.forEach((rowNode: any) => {
            if (!this.isDisabled(rowNode)) {
                s.push(rowNode);
            }
        });
        return s;
    }
    onGridReady(params: any) {
        this.grid = params;
        this.getOwnerDropdownList();
        this.getScheduledTypeDropdownList();
        this.grid.api.setGridOption('serverSideDatasource', this.setDatasource());
    }

    getScheduledTypeDropdownList() {
        this.scheduledService.getComboDropDownType().subscribe((res: IResponseObject) => {

            for (const record of res.responseData.items) {
                if (record.name) {
                    this.scheduledTypeList.push(record.name);
                }
            }
        });
    }

    isDisabled(data: any) {
        if (this.mdd && this.mdd.scheduledRebalances && this.mdd.scheduledRebalances.length > 0) {
            return this.mdd.scheduledRebalances ? this.mdd.scheduledRebalances.some((selectedRebalance: any) => {
                    return selectedRebalance.analysisId === data.analysisId
            }) : false;

        } else {
            return false;
        }
    }

}
